import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from './useAccount';

export const useSupplierOrders = (supplierId) => {
  const { accountId } = useAccount();

  const { isLoading, data, refetch } = useQuery(
    ['supplier-orders', accountId, supplierId],
    () =>
      api.fetchSupplierOrders({
        accountId,
        supplierId
      }),
    {
      cacheTime: 0
    }
  );

  return {
    refetch,
    isLoading,
    data: data?.data || []
  };
};
